import React from 'react'
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { FormattedMessage } from 'react-intl'
import { unitPrice } from '../../../../../../../utils/product'
import { Iconfont } from '../../../../../../components/icon/iconfont'


export const FilterBottomButton = props => {
    useStyles(classes)
	const {promotMsg, cartCount, onClose,cart,type} = props
    let regionalCase={}
    if((type==='0'||type===0) && cart?.regionalCases){
        regionalCase=cart?.regionalCases?.find(caseItem => caseItem.shipsFrom != 'US');
    }else if((type==='3'||type===3) && cart?.regionalCases){
        regionalCase=cart?.regionalCases?.find(caseItem => caseItem.shipsFrom === 'US');
    }
	return <div className={classes.FilterBottomButton}>
        <div className={classes.BottomButtonBox}>
            <div className={classes.LeftPartBox}>
                <div className={classes.BagIconBox}>
                    <Iconfont className={classes.BagIcon}>&#xe78e;</Iconfont>
                    <span className={classes.CartCountTip}>
                        {cartCount || 0}
                    </span>
                </div>
                <div className={classes.PriceBox}>
                    {
                        promotMsg?.total ?
                        <div>
                            <span className={classes.TotalNumSpan}>
                                {unitPrice(promotMsg.total)}
                            </span>
                        </div>:
                        <React.Fragment></React.Fragment>
                    }
                    {
                        promotMsg?.saved ?
                        <div>
                            <span className={classes.SaveSpan}>
                                <FormattedMessage id="saved" defaultMessage={'Saved'}/>
                            </span>
                            <span className={classes.SaveNumSpan}>
                                {unitPrice(promotMsg.saved)}
                            </span>
                        </div>:
                        <React.Fragment></React.Fragment>
                     }
                    {/* <div className={classes.CouponMsgSpan}>
                        <span dangerouslySetInnerHTML={{__html: promotMsg?.msg}}></span>
                    </div> */}
                </div>
            </div>

            <div className={classes.BackButtonDiv}>
                <button className={classes.BackButton} onClick={() => {
                    setTimeout(() => {
                        onClose()
                    }, 200)

                    if(window.GeekoSensors){
                        window.GeekoSensors.Track('ELClick', {
                            clicks: 'back_to_bag'
                        })
                    }
                }}><FormattedMessage id="go_to_bag" defaultMessage={'Go to Bag'}/></button>
                {   regionalCase?.shippingMsg?.freeMsg&&
                    <div className={classes.BackButtonFreeShipping}>
                        <span className={classes.FreeShipping}>
                                <FormattedMessage id="free_shipping" defaultMessage={'Free Shipping'}/>
                            </span>
                    </div>
                }
            </div>
        </div>
    </div>
}